import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { CreativeCredit } from 'sr-types/lib/shortlist/v1/graphql';
import { client } from '../../../shortlists/shortlist';
import { FETCH_POLICY_CONFIG } from '../../constants/constants';
import type { ExtractCreativeCreditsVariables } from '../types';
import { extractCreativeCreditsQuery } from './keyCreditsExtractionGraphqlApi';

export const useExtractCreativeCreditsApi = (activeOrganizationAccount: string) => {
    const [fetchCredits, { loading }] = useLazyQuery<
        { extractCreativeCredits: CreativeCredit[] },
        ExtractCreativeCreditsVariables
    >(extractCreativeCreditsQuery, {
        client,
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        }
    });

    const extractCreativeCredits = useCallback(
        async (variables: ExtractCreativeCreditsVariables) => {
            const result = await fetchCredits({ variables });
            if (result.error) {
                throw result.error;
            }
            return result.data?.extractCreativeCredits ?? [];
        },
        [fetchCredits]
    );

    return {
        extractCreativeCredits,
        loading
    };
};
